import { AppBar, Box, IconButton, Stack, Toolbar } from '@mui/material';
import { alpha, styled } from '@mui/material/styles';
import PropTypes from 'prop-types';
import { BsList } from "react-icons/bs";
import {AiOutlineHome} from "react-icons/ai";
import NotificationDropdown from './NotificationDropdown';
import Searchbar from './Searchbar';
import UserDropdown from './UserDropdown';

// ----------------------------------------------------------------------

const DRAWER_WIDTH = 280;
const APPBAR_MOBILE = 64;
const APPBAR_DESKTOP = 92;

const RootStyle = styled(AppBar)(({ theme }) => ({
  boxShadow: 'none',
  backdropFilter: 'blur(6px)',
  WebkitBackdropFilter: 'blur(6px)', // Fix on Mobile
  backgroundColor: alpha(theme.palette.background.default, 0.72),
  [theme.breakpoints.up('lg')]: {
    width: `calc(100% - ${DRAWER_WIDTH + 1}px)`,
  },
}));

const ToolbarStyle = styled(Toolbar)(({ theme }) => ({
  minHeight: APPBAR_MOBILE,
  [theme.breakpoints.up('lg')]: {
    minHeight: APPBAR_DESKTOP,
    padding: theme.spacing(0, 5),
  },
}));

const handleLink = event => {
  window.open('http://www.aladdinsci.net', '_blank', 'noopener,noreferrer');
}

// ----------------------------------------------------------------------

AdminNavbar.propTypes = {
  onOpenSidebar: PropTypes.func,
};

export default function AdminNavbar({ onOpenSidebar }) {
  return (
    <RootStyle>
      <ToolbarStyle>
        <IconButton onClick={onOpenSidebar} sx={{ mr: 1, color: 'text.primary', display: { lg: 'none' } }}>
          <BsList/>
        </IconButton>

        <Searchbar />
        <Box sx={{ flexGrow: 1 }} />

        <Stack direction="row" alignItems="center" spacing={{ xs: 1, sm: 4 }}>
          <IconButton color='default' aria-haspopup='true' onClick={handleLink} aria-controls='customized-menu'>
            <AiOutlineHome />
          </IconButton>
          {/* <NotificationDropdown/> */}
          <UserDropdown/>
        </Stack>
      </ToolbarStyle>
    </RootStyle>
  );
}
